import {IElementBase} from './base/elementBase';
import {ELEMENT} from './base/ElementTypes';

export enum VideoSourceType {
    'url' = 'url',
    'embedded' = 'embedded',
}

export interface IElementVideo extends IElementBase {
    type: ELEMENT.VIDEO;
    videoSource?: {src: string; type: VideoSourceType};
    /**
     * @deprecated This field is deprecated and will be removed in a future version.
     * Use videoSource instead.
     * when removing make videoSource required
     */
    videoSrc?: string;
    slideIsCurrent: boolean;
    size: number;
    widthHeightRatio: number;
}
